import CalendarLocale from 'bonree-picker/lib/locale/by_BY';
import TimePickerLocale from '../../time-picker/locale/by_BY';
const locale = {
    lang: Object.assign({ placeholder: 'Выберыце дату', yearPlaceholder: 'Выберыце год', quarterPlaceholder: 'Выберыце квартал', monthPlaceholder: 'Выберыце месяц', weekPlaceholder: 'Выберыце тыдзень', rangePlaceholder: ['Пачатковая дата', 'Канчатковая дата'], rangeYearPlaceholder: ['Пачатковы год', 'Год заканчэння'], rangeMonthPlaceholder: ['Пачатковы месяц', 'Канчатковы месяц'], rangeWeekPlaceholder: ['Пачатковы тыдзень', 'Канчатковы тыдзень'] }, CalendarLocale),
    timePickerLocale: Object.assign({}, TimePickerLocale),
};
export default locale;
